module.exports = __webpack_public_path__ + "static/media/290528.2a575df1.png";